import React from 'react'

import {
    Create,
    maxLength,
    minLength,
    required,
    SimpleForm,
    useNotify,
    useRedirect,
    useTranslate,
} from 'react-admin'
import { Typography, useTheme } from '@mui/material';
import styledFormInputs from '../../../ui/inputs/styledFormInputs';
import NavigateBackBtn from '../../../ui/button/NavigateBackBtn';



const validateRequired = [required('Champs obligatoire')]




const VoucherCreate = ({ classes, ...props }) => {
    const translate = useTranslate();
    const theme = useTheme();
    const notify = useNotify();
    const redirect = useRedirect();


    const inputsDataGeneral = [
        { name: 'voucher_count', label: translate('resources.vouchers.voucher_count'), validate: validateRequired, type: "number" },
        { name: 'batch_description', label: translate('resources.vouchers.batch_description'), validate: [required(), minLength(10, translate("resources.vouchers.description_min_length")), maxLength(50, translate("resources.vouchers.description_max_length"))], type: "text" },
        { name: 'root_organization_id', label: translate('resources.vouchers.root_organization_id'), validate: validateRequired, type: "reference", reference: "root_organizations", optionText: "name" },
        {
            name: 'plan_id', label: translate('resources.vouchers.plan_id'), validate: validateRequired, type: "reference", reference: "device_sub_plans",
            optionText: ((p) => `RO:(${p.root_organization_id?.substring(0, 5)}) ${p.title}`)
        },
    ]



    const onSuccess = () => {
        notify(translate('resources.vouchers.create_success'));
        redirect('/vouchers');
    }

    return (
        <>
            <Typography sx={{ color: theme.palette.text.primary, textAlign: 'start', fontWeight: 700, fontSize: "24px", lineHeight: "42px", margin: "0px 0px 16px 0px" }}>
                <NavigateBackBtn /> {translate('resources.vouchers.create')}
            </Typography>
            <Create
                redirect="list"
                title={'resources.vouchers.create'}
                sx={{
                    "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.paper,
                        color: theme.palette.text.primary,
                    },
                }}
                mutationOptions={{ onSuccess }}
            >
                <SimpleForm >

                    <Typography color="text.main" sx={{
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        fontWeight: 700,
                        lineHeight: "25px",
                        textAlign: "center",
                        margin: "0px 0px 10px 0px"
                    }}
                    >
                        {translate('resources.vouchers.sections.general')}
                    </Typography>
                    {styledFormInputs(inputsDataGeneral)}

                </SimpleForm>
            </Create>
        </>
    )
}

export default VoucherCreate



